import { Card, Typography } from "@powerdiary/components-library/lib";
import { alpha, useTheme } from "@mui/material";
import { amountToCurrency } from "utils/localeHelper";
import { useClientPortalConfigContext } from "context/ClientPortalConfig.ctx";
import { useMemo } from "react";
import { IServiceData } from "../../../../../bookingSlice.types";

interface PaymentDetailsProps {
    totalAmount: number;
    service: IServiceData;
    discountContent?: string | null;
}

export default function PaymentDetails({ service, totalAmount, discountContent }: PaymentDetailsProps) {
    const { palette: muiPalette } = useTheme();
    const {
        clientPortalConfig: { currencySymbol },
    } = useClientPortalConfigContext();

    const cardSx = useMemo(
        () => ({
            display: "flex",
            borderRadius: "4px",
            backgroundColor: alpha(muiPalette.primary.main, 0.1),
            border: `1px solid ${alpha(muiPalette.primary.main, 0.1)}`,
        }),
        [muiPalette]
    );

    return (
        <Card sx={cardSx} data-test-id="section_payment_details">
            {service?.needsDeposit ? (
                <Typography variant="paragraphExtraLargeRegular">
                    Pay a deposit of{" "}
                    <Typography variant="paragraphExtraLargeBold" data-test-id="text_payment_deposit_amount">
                        {amountToCurrency(totalAmount, currencySymbol)}
                    </Typography>
                    {discountContent && (
                        <Typography
                            variant="paragraphSmallRegular"
                            color="textSecondary"
                            sx={{ display: "block", mt: 0.5 }}
                        >
                            {discountContent}
                        </Typography>
                    )}
                </Typography>
            ) : (
                <Typography variant="paragraphExtraLargeRegular">
                    Amount:{" "}
                    <Typography variant="paragraphExtraLargeBold" data-test-id="text_invoice_total_amount">
                        {amountToCurrency(totalAmount, currencySymbol)}
                    </Typography>
                    {discountContent && (
                        <Typography
                            variant="paragraphSmallRegular"
                            color="textSecondary"
                            sx={{ display: "block", mt: 0.5 }}
                        >
                            {discountContent}
                        </Typography>
                    )}
                </Typography>
            )}
        </Card>
    );
}
